export const LockIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='text-[var(--mui-palette-warning-main)]'
    >
      <rect
        x='6'
        y='10'
        width='12'
        height='8'
        rx='2'
        stroke='currentColor'
        strokeWidth='2'
        fill='var(--mui-palette-background-paper)'
      />
      <path
        d='M9 10V8a3 3 0 0 1 6 0v2'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <circle cx='12' cy='14' r='1' fill='currentColor' />
    </svg>
  );
};
